import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {
    // 基础信息
    const familyTableColumns = [
        {
            label: "关系",
            prop: "relationship",
            show: true,
            align: "center",
        },
        {
            label: "亲属姓名",
            prop: "name",
            show: true,
            align: "center",
        },
        {
            label: "出生日期",
            prop: "dateBirth",
            align: "center",
            type: 'date',
            show: true
        },
        // {
        //     label: "学历",
        //     prop: "degree",
        //     show: true,
        //     align: "center",
        // },
        {
            label: "政治面貌",
            prop: "politicalCode",
            type: 'select',
            show: true,
            align: "center",
        },
        {
            label: "单位",
            prop: "unit",
            show: true,
            align: "center",
        },
        {
            label: "联系电话",
            prop: "contactPhone",
            show: true,
            align: "center",
        },
        {
            label: "职业",
            prop: "job",
            show: true,
            align: "center",
        },
        // {
        //     label: "收入（元）",
        //     prop: "income",
        //     align: "center",
        //     show: true
        // },
        {
            label: "备注",
            prop: "remark",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "custom",
            align: "center",
            width: '260px',
            show: true
        }
    ]


    const familyFormItems = [
        {
            label: "关系",
            span: 24,
            model: "relationship",
            placeholder:'如：父子'
        },
        {
            label: "亲属姓名",
            span: 24,
            model: "name",
        },
        {
            span: 24,
            label: "出生日期",
            model: "dateBirth",
            type: 'date',
        },
        // {
        //     label: "学历",
        //     span: 24,
        //     model: "degree",
        // },
        {
            label: "政治面貌",
            span: 24,
            model: "politicalCode",
            // type: 'select'
        },
        {
            label: "单位",
            span: 24,
            model: "unit",
        },
        {
            label: "联系电话",
            span: 24,
            model: "contactPhone",
        },
        {
            label: "职业",
            span: 24,
            model: "job",
        },
        // {
        //     span: 24,
        //     label: "收入（元）",
        //     model: "income",
        // },
        {
            label: "备注",
            span: 24,
            model: "remark",
        },
    ]




    const familyFormRules = {
        name: [{
            required: true,
            message: "请输入亲属姓名",
            trigger: "blur"
        }],
        relationship: [{
            required: true,
            message: "请输入亲属关系",
            trigger: "blur"
        }],
    }

    return {
        familyTableColumns,
        familyFormItems,
        familyFormRules,
    }
}
